(() => {
  if (window.NiuyuExperience) return;
  const analyticsAllowed = () => {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true; }
    catch { return false; }
  };
  const track = (event, detail = {}) => {
    const shop = window.Shopify;
    if (shop?.designMode || shop?.theme?.role !== 'main') return;
    if (!analyticsAllowed()) return;
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({event, ...detail});
    } catch { /* Analytics must never interrupt a purchase. */ }
  };
  const dateLabel = date => new Intl.DateTimeFormat('es-MX', {weekday:'short',day:'numeric',month:'short',timeZone:'UTC'}).format(date);
  function estimate(now = new Date()) {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-CA', {timeZone:'America/Mexico_City',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',hourCycle:'h23'}).formatToParts(now).map(p=>[p.type,p.value]));
    const ship = new Date(Date.UTC(Number(parts.year), Number(parts.month)-1, Number(parts.day)));
    if (Number(parts.hour) >= 14) ship.setUTCDate(ship.getUTCDate()+1);
    while ([0,6].includes(ship.getUTCDay())) ship.setUTCDate(ship.getUTCDate()+1);
    const addDays = count => {
      const result = new Date(ship);
      while(count) { result.setUTCDate(result.getUTCDate()+1); if(![0,6].includes(result.getUTCDay())) count--; }
      return result;
    };
    return `Salida estimada: ${dateLabel(ship)} · Entrega: ${dateLabel(addDays(2))} a ${dateLabel(addDays(4))}. Sujeto a cobertura y días festivos.`;
  }
  function init() {
    document.querySelectorAll('[data-delivery-estimate]').forEach(el=>{el.textContent=estimate();});
    if (window.Shopify?.theme?.role === 'main' && !window.Shopify.designMode && analyticsAllowed() && typeof window.clarity === 'function') {
      try { window.clarity('set','variant','cro-staging'); } catch {}
    }
    if ('IntersectionObserver' in window) document.querySelectorAll('[data-delivery-estimate]:not([data-measured])').forEach(el=>{
      el.dataset.measured='true';
      const observer=new IntersectionObserver(entries=>{
        if(entries.some(entry=>entry.isIntersecting)) {track('delivery_date_view',{date_shown:el.textContent});observer.disconnect();}
      });
      observer.observe(el);
    });
    document.querySelectorAll('[data-niuyu-details]:not([data-ready])').forEach(root=>{
      root.dataset.ready='true';
      const tabs=[...root.querySelectorAll('[data-detail-tab]')], panels=[...root.querySelectorAll('[data-detail-panel]')];
      root.querySelector('[role=tablist]').hidden=false;
      let active=0, combined=false;
      function activate(index, focus=false) {
        active=combined && index===2 ? 0 : index;
        tabs.forEach((tab,i)=>{
          const selected=i===active;
          tab.setAttribute('aria-selected',String(selected));
          tab.tabIndex=selected?0:-1;
          const merged=combined && i===2;
          panels[i].hidden=merged ? active!==0 : !selected;
          panels[i].setAttribute('role',merged?'region':'tabpanel');
          panels[i].setAttribute('aria-labelledby',merged?panels[i].querySelector('h3').id:tab.id);
          panels[i].tabIndex=merged?-1:0;
        });
        if(focus) tabs[active].focus();
      }
      function resizeTabs() {
        const next=root.clientWidth<350;
        if(next===combined) return;
        const hadFocus=tabs[2]===document.activeElement;
        combined=next;
        root.toggleAttribute('data-combined',combined);
        tabs[2].hidden=combined;
        // Move, rather than duplicate, benefits into Description on narrow panels.
        if(combined) panels[0].append(panels[2]);
        else root.insertBefore(panels[2],panels[3]);
        activate(active,hadFocus);
      }
      tabs.forEach((tab,i)=>{
        tab.addEventListener('click',()=>{activate(i);track('pdp_tab_click',{tab:tab.textContent,product:root.dataset.product});});
        tab.addEventListener('keydown',event=>{
          const visible=tabs.filter(tab=>!tab.hidden), current=visible.indexOf(tab);
          let target;
          if(event.key==='ArrowRight') target=visible[(current+1)%visible.length];
          else if(event.key==='ArrowLeft') target=visible[(current+visible.length-1)%visible.length];
          else if(event.key==='Home') target=visible[0];
          else if(event.key==='End') target=visible[visible.length-1];
          else return;
          event.preventDefault();activate(tabs.indexOf(target),true);
        });
      });
      activate(0);
      resizeTabs();
      if('ResizeObserver' in window) {
        const observer=new ResizeObserver(resizeTabs);
        observer.observe(root);
        const remove=event=>{
          if(!event.target.contains(root)) return;
          observer.disconnect();
          document.removeEventListener('shopify:section:unload',remove);
        };
        document.addEventListener('shopify:section:unload',remove);
      }
    });
  }
  window.NiuyuExperience={track,estimate,init};
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('cart:refresh',init);
  document.addEventListener('cart:updated',init);
  document.addEventListener('submit', async event => {
    const form=event.target.closest('[data-niuyu-upsell], [data-niuyu-pair], [data-niuyu-kit]');
    if(!form) return;
    event.preventDefault();
    if(form.dataset.busy) return;
    form.dataset.busy='true';
    const button=form.querySelector('button'), error=form.querySelector('[role=alert]');
    button.disabled=true;button.setAttribute('aria-busy','true');error.hidden=true;
    const isPair=form.hasAttribute('data-niuyu-pair');
    const eventPrefix=isPair?'home_pair':form.hasAttribute('data-niuyu-kit')?'kit_card':'cart_upsell';
    track(eventPrefix+'_click',{sku_suggested:form.dataset.sku});
    try {
      const items = form.hasAttribute('data-niuyu-pair')
        ? [0,1].map(index=>({id:Number(form.elements['items['+index+'][id]'].value),quantity:1}))
        : [{id:Number(form.elements.id.value),quantity:1}];
      const response=await fetch((window.Shopify?.routes?.root || '/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
      const result=await response.json();
      if(!response.ok) throw Error(result.description || 'No se pudo agregar. Intenta de nuevo.');
      track(eventPrefix+'_add',{sku_added:form.dataset.sku});
      document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{open:true}}));
    } catch(e) { error.textContent=e.message;error.hidden=false; }
    finally {button.disabled=false;button.removeAttribute('aria-busy');delete form.dataset.busy;}
  });
  // 28-sep: "Súbele a tu kit" en el carrito · agrega el kit nuevo y, si entró, quita el anterior
  document.addEventListener('submit',async event=>{
    const form=event.target.closest('[data-niuyu-kitup]');
    if(!form) return;
    event.preventDefault();
    if(form.dataset.busy) return;
    form.dataset.busy='true';
    const button=form.querySelector('button'), error=form.querySelector('[role=alert]');
    button.disabled=true;button.setAttribute('aria-busy','true');error.hidden=true;
    track('cart_kitup_click',{sku_suggested:form.dataset.sku});
    const root=(window.Shopify?.routes?.root || '/');
    try {
      const add=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(form.elements.id.value),quantity:1}]})});
      const added=await add.json();
      if(!add.ok) throw Error(added.description || 'No se pudo cambiar el kit. Intenta de nuevo.');
      await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:form.dataset.removeKey,quantity:0})});
      track('cart_kitup_add',{sku_added:form.dataset.sku});
      document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{open:true}}));
    } catch(e) { error.textContent=e.message;error.hidden=false; }
    finally {button.disabled=false;button.removeAttribute('aria-busy');delete form.dataset.busy;}
  });
  setInterval(()=>document.querySelectorAll('[data-delivery-estimate]').forEach(el=>{el.textContent=estimate();}),60000);
  document.addEventListener('click',event=>{
    const pack=event.target.closest('[data-niuyu-pack]');
    if(pack) track('pdp_plan_select',{plan:pack.dataset.qty+'x',product:pack.closest('[data-niuyu-pdp]')?.dataset.productId});
    const sticky=event.target.closest('[data-niuyu-sticky-btn]');
    if(sticky) track('sticky_atc_click',{product:sticky.closest('[data-niuyu-pdp]')?.dataset.productId,plan:sticky.closest('[data-niuyu-pdp]')?.querySelector('[data-niuyu-pack].is-active')?.dataset.qty});
    const card=event.target.closest('.niuyu-card');
    if(card) track('home_card_click',{product:card.getAttribute('href')});
    const hero=event.target.closest('.niuyu-hero__btn');
    if(hero) track('home_hero_cta',{cta:hero.textContent.trim()});
  });
})();

/* R9: estrellitas ✦ → estrella dibujada (centrada y del mismo tamaño en todos los teléfonos) */
(function(){
  var SEL='[class*="kicker"],[class*="eyebrow"],[class*="__eye"],[class*="__k"],[class*="-k"],.m-promotion__text,.niuyu-allgrp__head,.niuyu-collhead,h1,h2,h3,p,li';
  function starify(root){
    (root||document).querySelectorAll(SEL).forEach(function(el){
      if(el.closest('script,style,textarea,input,.m-cart-drawer__empty')) return;
      var w=document.createTreeWalker(el,NodeFilter.SHOW_TEXT,null), n, list=[];
      while((n=w.nextNode())){ if(n.nodeValue.indexOf('✦')!==-1 && !(n.parentNode&&n.parentNode.classList&&n.parentNode.classList.contains('niu-star'))) list.push(n); }
      list.forEach(function(t){
        var parts=t.nodeValue.split('✦'); if(parts.length<2) return;
        var f=document.createDocumentFragment();
        parts.forEach(function(p,i){ if(p) f.appendChild(document.createTextNode(p)); if(i<parts.length-1){ var s=document.createElement('span'); s.className='niu-star'; s.setAttribute('aria-hidden','true'); f.appendChild(s);} });
        t.parentNode.replaceChild(f,t);
      });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){starify();}); else starify();
  document.addEventListener('shopify:section:load',function(e){starify(e.target);});
  document.addEventListener('cart:updated',function(){setTimeout(function(){starify(document.getElementById('MinimogCartDrawer'));},50);});
  document.addEventListener('cart:refresh',function(){setTimeout(function(){starify(document.getElementById('MinimogCartDrawer'));},900);});
  window.NiuyuStarify=starify;
})();

/* R9b: kickers de una línea en celular: si no cabe, baja el tamaño poco a poco (mín. 8.5px) */
(function(){
  function fit(){
    if (window.innerWidth > 767) return;
    document.querySelectorAll('.niuyu-pdp__kicker').forEach(function(el){
      el.style.removeProperty('font-size');
      var fs=parseFloat(getComputedStyle(el).fontSize)||12, guard=0;
      while(el.scrollWidth>el.clientWidth+1 && fs>8.5 && guard<20){ fs-=0.5; el.style.setProperty('font-size', fs+'px', 'important'); guard++; }
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ fit(); setTimeout(fit,300); }); else { fit(); setTimeout(fit,300); }
  window.addEventListener('resize',function(){ clearTimeout(fit._t); fit._t=setTimeout(fit,150); });
  if(document.fonts&&document.fonts.ready) document.fonts.ready.then(fit);
})();

/* R9c: alinear tarjetas en la misma fila (mismo renglón para nombre, estrellas, texto, chips, regalo y precio) */
(function(){
  var SETS = [
    { card: '.niuyu-kitc', parts: ['.niuyu-kitc__top', '.niuyu-kitc__name', '.niuyu-kitc__rating', '.niuyu-kitc__benefit', '.niuyu-kitc__portions', '.niuyu-kitc__gift'] },
    { card: '.niuyu-duos__card', parts: ['.niuyu-duos__name', '.niuyu-duos__benefit', '.niuyu-duos__portions', '.niuyu-duos__giftline', '.niuyu-duos__pricing'] }
  ];
  function align(){
    if (window.NiuyuFitTitles) window.NiuyuFitTitles();
    SETS.forEach(function(set){
      var cards = [].slice.call(document.querySelectorAll(set.card)).filter(function(c){ return c.offsetParent !== null; });
      set.parts.forEach(function(sel){ cards.forEach(function(c){ var el=c.querySelector(sel); if(el) el.style.minHeight=''; }); });
      // agrupar por contenedor + fila (misma altura en pantalla); en carrusel todas cuentan como una fila
      var groups = {};
      cards.forEach(function(c){
        var parent = c.parentElement, key;
        var scroller = getComputedStyle(parent).overflowX === 'auto' || getComputedStyle(parent).overflowX === 'scroll';
        key = (parent.dataset.niuAlignId || (parent.dataset.niuAlignId = Math.random().toString(36).slice(2))) + ':' + (scroller ? 'row' : Math.round(c.offsetTop));
        (groups[key] = groups[key] || []).push(c);
      });
      Object.keys(groups).forEach(function(k){
        var g = groups[k]; if (g.length < 2) return;
        set.parts.forEach(function(sel){
          var els = g.map(function(c){ return c.querySelector(sel); }).filter(function(e){ return e && getComputedStyle(e).display !== 'none'; });
          if (els.length < 2) return;
          var max = Math.max.apply(null, els.map(function(e){ return e.getBoundingClientRect().height; }));
          els.forEach(function(e){ e.style.minHeight = Math.ceil(max) + 'px'; });
        });
      });
    });
  }
  var t; function later(){ clearTimeout(t); t=setTimeout(align,120); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',later); else later();
  window.addEventListener('load',later); window.addEventListener('resize',later);
  if(document.fonts&&document.fonts.ready) document.fonts.ready.then(later);
  document.addEventListener('shopify:section:load',later);
  window.NiuyuAlignCards=align;
})();

/* R9d: si una palabra del nombre del producto no cabe, baja el tamaño hasta que quepa (no la parte) */
(function(){
  function fitTitle(){
    document.querySelectorAll('.niuyu-pdp__title, .niuyu-duos__name, .niuyu-kitc__cat').forEach(function(el){
      el.style.removeProperty('font-size');
      var fs=parseFloat(getComputedStyle(el).fontSize)||48, guard=0;
      var min = el.classList.contains('niuyu-duos__name') ? 16 : el.classList.contains('niuyu-kitc__cat') ? 6.5 : (el.closest && el.closest('.niuyu-pdp-simple')) ? 14 : 28;
      var step = min < 10 ? 0.25 : 1;
      while(el.scrollWidth>el.clientWidth+1 && fs>min && guard<40){ fs-=step; el.style.setProperty('font-size', fs+'px', 'important'); guard++; }
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fitTitle); else fitTitle();
  window.addEventListener('load',fitTitle);
  window.addEventListener('resize',function(){ clearTimeout(fitTitle._t); fitTitle._t=setTimeout(fitTitle,150); });
  if(document.fonts&&document.fonts.ready) document.fonts.ready.then(fitTitle);
  // dúos: todos los nombres con el mismo tamaño (el más chico del grupo), para que se vean parejos
  var baseFit = fitTitle;
  fitTitle = function(){
    baseFit();
    var names=[].slice.call(document.querySelectorAll('.niuyu-duos__name')).filter(function(n){return n.offsetParent;});
    if(names.length>1){ var m=Math.min.apply(null,names.map(function(n){return parseFloat(getComputedStyle(n).fontSize);})); names.forEach(function(n){ n.style.setProperty('font-size', m+'px', 'important'); }); }
  };
  window.addEventListener('load',fitTitle);
  window.NiuyuFitTitles=fitTitle;
})();

/* NIÜ Community: la sombra de una tarjeta cortada por el borde del carrusel se oculta (evita la "línea" suelta al hacer scroll) */
(function () {
  // 28-sep: revision INMEDIATA (sin IntersectionObserver): en iPhone el primer aviso del
  // observer llegaba tarde y la sombra "aparecia despues". Solo cuenta el corte lateral.
  function bind() {
    document.querySelectorAll('.nhc-v2__row').forEach(function (row) {
      if (row.__niuCut) return; row.__niuCut = true;
      var raf = 0;
      function upd() {
        raf = 0;
        var rr = row.getBoundingClientRect();
        row.querySelectorAll('.nhc-v2__item').forEach(function (it) {
          var r = it.getBoundingClientRect();
          it.classList.toggle('niu-cut', r.left < rr.left - 2 || r.right > rr.right + 2);
        });
      }
      function sched() { if (!raf) raf = requestAnimationFrame(upd); }
      upd();
      row.addEventListener('scroll', sched, { passive: true });
      window.addEventListener('resize', sched);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
})();
